"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var FieldDropzone_1 = __importDefault(require("components/Form/FieldDropzone"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var DropzoneType = function () {
    var _a = __read(react_1.default.useState(false), 2), isSubmitted = _a[0], setSubmitted = _a[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, setSubmitted(true)];
    }); }); };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Got a quote for Auth0?" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mt: 1 }, { children: "Upload it here \uD83D\uDC47 to get a second opinion." })), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ width: "50%" }, { children: [(0, jsx_runtime_1.jsx)(FieldDropzone_1.default, { name: "dropFile", maxFiles: 3 }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "notes", color: "secondary", label: "Add notes here", component: TextField_1.default, multiline: true, rows: 2 }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleSubmit, sx: { ml: 'auto' }, type: "submit", disabled: submitting }, { children: "Submit" })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ p: 2, pr: 5, my: 2, width: "100%", sx: { bgcolor: 'green.light', borderRadius: 1 }, visibility: isSubmitted ? 'visible' : 'hidden' }, { children: "\u2705   Thanks for uploading your quote/invoice. We\u2019ll be in touch by email shortly." }))] })));
                } }))] }));
};
exports.default = DropzoneType;
